export default __webpack_public_path__ + "static/media/splashscreen.4932889a.png";